import { render, staticRenderFns } from "./CSelect.vue?vue&type=template&id=34b5359e&scoped=true"
import script from "./CSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSelect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CSelect.vue?vue&type=style&index=0&id=34b5359e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b5359e",
  null
  
)

export default component.exports